/**
 * Created by olga on 14.10.2026
 */

const BackpackHintView = function () {
    this.unitView = undefined;
    this.backpackButton = undefined;
    this.pullAction = undefined;
    this.baseUnitZOrder = undefined;
    this.tutorialMode = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("backpack", this.show.bind(this));
};

BackpackHintView.prototype.show = function (move, inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    this.hide(inTutorial);

    const unit = Merge2.current.field.getUnit(move.cell.x, move.cell.y);
    const unitView = unit && unit.onGetView();
    const backpackButton = cleverapps.aims.getTarget("backpack", { noDefault: true });
    if (!unitView || !unitView.parent || !backpackButton || !backpackButton.parent) {
        return;
    }

    const options = {
        delay: move.delay / 1000,
        interval: move.interval / 1000
    };

    this.unitView = unitView;
    this.backpackButton = backpackButton;

    this.startPull(options);
    backpackButton.startHintPulse(options);
};

BackpackHintView.prototype.startPull = function (options) {
    const unitView = this.unitView;

    this.pullAction = unitView.runAction(new cc.Sequence(
        new cc.DelayTime(options.delay),
        new cc.CallFunc(() => {
            if (this.unitView !== unitView || !unitView.parent || !this.backpackButton.parent) {
                return;
            }

            const shift = this.calculateShift();

            const position = unitView.getPosition();
            const baseUnitZOrder = unitView.getLocalZOrder();
            this.baseUnitZOrder = baseUnitZOrder;
            unitView.setLocalZOrder(this.baseUnitZOrder + 1);

            this.pullAction = unitView.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.MoveBy(0.5, shift.x, shift.y).easing(cc.easeInOut(2)),
                new cc.DelayTime(0.1),
                new cc.MoveBy(0.6, -shift.x, -shift.y).easing(cc.easeInOut(2))
            ))).setFinalize(() => {
                unitView.setPosition(position);
                unitView.setLocalZOrder(baseUnitZOrder);
            });
        })
    ));
};

BackpackHintView.prototype.calculateShift = function () {
    const unitView = this.unitView;
    const backpackButton = this.backpackButton;

    const position = Merge2.current.field.getMapView().alignInGrid(unitView.unit.x, unitView.unit.y);
    const target = unitView.parent.convertToNodeSpace(backpackButton.parent.convertToWorldSpace(backpackButton.getPosition()));

    const dx = target.x - position.x;
    const dy = target.y - position.y;

    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance <= 0) {
        return cc.p(0, 0);
    }

    const length = cleverapps.styles.BackpackHintView.pullLength;
    return cc.p(dx / distance * length, dy / distance * length);
};

BackpackHintView.prototype.hide = function (inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    const unitView = this.unitView;
    const backpackButton = this.backpackButton;
    const pullAction = this.pullAction;
    const baseUnitZOrder = this.baseUnitZOrder;
    this.unitView = undefined;
    this.backpackButton = undefined;
    this.pullAction = undefined;
    this.baseUnitZOrder = undefined;

    if (unitView && unitView.parent && pullAction) {
        unitView.stopAction(pullAction);

        const position = Merge2.current.field.getMapView().alignInGrid(unitView.unit.x, unitView.unit.y);
        unitView.runAction(new cc.MoveTo(0.1, position.x, position.y)).setFinalize(() => {
            unitView.setPosition(position);
            if (baseUnitZOrder !== undefined) {
                unitView.setLocalZOrder(baseUnitZOrder);
            }
        });
    }

    if (backpackButton) {
        backpackButton.stopHintPulse();
    }
};

BackpackHintView.prototype.setTutorialMode = function (tutorialMode) {
    this.tutorialMode = tutorialMode;
};

cleverapps.styles.BackpackHintView = {
    pullLength: 46
};
